module.exports = __webpack_public_path__ + "static/media/cancel-square-black.ef69a08e.svg";